import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Grid, Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { getDeviceEnabledTypesIds } from '@iotv/payload-definition';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { getGraphQueryRequestV2 } from '../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { AppLocalStorage } from '../../data/LocalStorage/AppLocalStorage';
import { convertListToSelectorMinimum } from '../common/DeviceGenerics';
import { NavSections } from '../navigation/NavSections';
import CurrentLocationMap from './CurrentLocationMap';
import { DeviceLinkContext } from './DeviceLinkContext';
import LinkingDBTransactions from './LinkingDBTransactions';
import LinkingDeviceDetails from './LinkingDeviceDetails';
import LinkingEntity from './LinkingEntity';
import LinkingLocation from './LinkingLocation';
import LinkingType from './LinkingType';
import { getCustomerDevGroupsAndAreas } from './Support/LinkingQueries';
import UnlinkingDevices from './UnlinkingDevices';
import { Invalid } from '../../components/Invalid';
import { isAdminRole } from '../../helpers/access';
const COMPONENT_WIDTH = '300px';
const componentClassName = 'LinkingView';
const LinkingView = (props) => {
    const [{ userSelectedGroup, contextCustomer, contextProperty, isSmallView }] = useContext(AppMainViewContext);
    const [device, setDevice] = useState();
    const [entityOptions, setEntityOptions] = useState([]);
    const [entityList, setEntityList] = useState([]);
    const [selectedEntityType, setSelectedEntityType] = useState(undefined);
    const [choosenEntity, setChoosenEntity] = useState();
    const [prelinkedDevice, setPrelinkedDevice] = useState();
    const [unlinkDevice, setUnlinkDevice] = useState();
    const [updateLocation, setUpdateLocation] = useState(true);
    const [currentLocation, setCurrentLocation] = useState();
    const [allowEntities, setAllowEntities] = useState(true);
    const [deviceGroups, setDeviceGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState();
    const [areaList, setAreaList] = useState([]);
    const [resetter, setResetter] = useState(0);
    const [relevantAreas, setRelevantArea] = useState([]);
    const hyperOrVenture = isAdminRole(userSelectedGroup);
    const clearAfterSuccess = () => {
        setRelevantArea([]);
        setPrelinkedDevice(undefined);
        setUnlinkDevice(undefined);
        setSelectedGroup(undefined);
        setChoosenEntity(undefined);
        setSelectedEntityType(undefined);
        setResetter((reset) => reset + 1);
    };
    const clearPreset = () => {
        setRelevantArea([]);
        setPrelinkedDevice(undefined);
        setUnlinkDevice(undefined);
        setSelectedGroup(undefined);
        setChoosenEntity(undefined);
        setSelectedEntityType(undefined);
    };
    useEffect(() => {
        const previousOption = AppLocalStorage.get(NavSections.LINK_DEVICE_TO_ENTITY, 'updateLocation');
        if (typeof previousOption === 'boolean') {
            setUpdateLocation(previousOption);
        }
    }, []);
    useEffect(() => {
        AppLocalStorage.set(NavSections.LINK_DEVICE_TO_ENTITY, 'updateLocation', updateLocation);
    }, [updateLocation]);
    useEffect(() => {
        if (contextCustomer) {
            // get customer device groups and areas
            getGraphQueryRequestV2({
                contextObjects: [contextCustomer],
                query: getCustomerDevGroupsAndAreas().query,
            }).then((e) => {
                if (e.data) {
                    const groups = e.data.getNodesOfType('Group');
                    setDeviceGroups(groups);
                    if (contextProperty) {
                        const areas = e.data.getChildNodes(contextProperty);
                        setAreaList(areas);
                    }
                    else {
                        const areas = e.data.getNodesOfType('Area');
                        setAreaList(areas);
                    }
                }
                else {
                    console.warn('DeviceToEntityView', 'no data');
                }
            });
        }
    }, [contextCustomer]); // contextProperty
    useEffect(() => {
        if (device) {
            const deviceEnabledTypeIds = getDeviceEnabledTypesIds(device);
            const options = convertListToSelectorMinimum(deviceEnabledTypeIds);
            setEntityOptions(options);
            if (options.length === 1) {
                setSelectedEntityType(options[0]);
            }
        }
        else {
            setEntityOptions([]);
        }
    }, [device]);
    if (!hyperOrVenture) {
        return _jsx(Invalid, {});
    }
    return (_jsx(DeviceLinkContext.Provider, { value: {
            device,
            prelinkedDevice,
            location: currentLocation,
            updateLocation,
            unlinkDevice,
            allowEntities,
            entityOptions,
            selectedEntityType,
            choosenEntity,
            deviceGroups,
            selectedGroup,
            areaList,
            entityList,
            relevantAreas,
        }, children: _jsx(Container, { className: componentClassName, style: { maxWidth: 'unset' }, children: _jsxs(Stack, { direction: "row", spacing: 2, children: [_jsxs("div", { style: { minWidth: COMPONENT_WIDTH }, children: [_jsx(Typography, { variant: "h5", component: "h5", color: "primary", children: "Device Linking" }), _jsxs(Grid, { spacing: 2, children: [_jsx(LinkingLocation, { setLocation: setCurrentLocation, setUpdateLocation: setUpdateLocation }, '1)GetLocations'), isSmallView && currentLocation && _jsx(CurrentLocationMap, {}), _jsx(LinkingDeviceDetails, { clear: clearPreset, resetter: resetter, setDevice: setDevice, setAllowEntities: setAllowEntities }, '2)GetEUIs'), _jsx(LinkingType, { setSelectedEntity: setSelectedEntityType }, '3)4)SelectEntityType'), _jsx(LinkingEntity, { setEntityList: setEntityList, setChoosenEntity: setChoosenEntity, setPrelinkedDevice: setPrelinkedDevice, setUnlinkDevice: setUnlinkDevice }, '5)SelectEntity'), prelinkedDevice && prelinkedDevice.length > 0 && _jsx(UnlinkingDevices, { setUnlinkDevice: setUnlinkDevice }, '8)UnlinkDevice'), _jsx(LinkingDBTransactions, { clear: clearAfterSuccess }, 'LinkingDBActions')] })] }), !isSmallView && _jsx("div", { style: { width: `calc(100% - ${COMPONENT_WIDTH})`, height: '90vh' }, children: currentLocation && _jsx(CurrentLocationMap, {}) })] }) }) }));
};
export default LinkingView;
